module.exports = __webpack_public_path__ + "img/zzdz.805d1f5b.gif";